module.exports = __webpack_public_path__ + "mainassets/img/form_footer.b14e042e.svg";